// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7KEaw","name":"styles_name__1-fBv","phone":"styles_phone__25vs6"};